export const TANK_CLASSES = {
    balanced: {
        id: "balanced", name: "Balanced", role: "All-rounder",
        maxHp: 100, maxSpeed: 15, accel: 18, turnSpeed: 2.2, radius: 1.4,
        fireCooldownMs: 500, projectileSpeed: 38, projectileDamage: 20, projectileTtlMs: 3000,
        scale: 1.0, selectable: true,
        ability: { id: "repair", name: "Repair", cooldownMs: 11000, desc: "Heal +25 instantly and regenerate over 3s." },
    },
    heavy: {
        id: "heavy", name: "Heavy", role: "Brawler",
        maxHp: 160, maxSpeed: 10.5, accel: 10, turnSpeed: 1.6, radius: 1.5,
        fireCooldownMs: 780, projectileSpeed: 34, projectileDamage: 32, projectileTtlMs: 3000,
        scale: 1.12, selectable: true,
        ability: { id: "bulwark", name: "Bulwark", cooldownMs: 14000, desc: "Take 50% less damage for 4s." },
    },
    scout: {
        id: "scout", name: "Scout", role: "Harasser",
        maxHp: 70, maxSpeed: 22, accel: 30, turnSpeed: 3.0, radius: 1.2,
        fireCooldownMs: 280, projectileSpeed: 44, projectileDamage: 12, projectileTtlMs: 2500,
        scale: 0.88, selectable: true,
        ability: { id: "dash", name: "Dash", cooldownMs: 6000, desc: "Blink forward and become briefly invulnerable." },
    },
    artillery: {
        id: "artillery", name: "Artillery", role: "Siege",
        maxHp: 80, maxSpeed: 9.5, accel: 9, turnSpeed: 1.5, radius: 1.5,
        fireCooldownMs: 950, projectileSpeed: 30, projectileDamage: 40, projectileTtlMs: 4000,
        scale: 1.06, selectable: true,
        ability: { id: "mortar", name: "Mortar Strike", cooldownMs: 9000, desc: "Lob an AOE shell onto your aim point." },
    },
    bot: {
        id: "bot", name: "Bot", role: "Enemy",
        maxHp: 60, maxSpeed: 10, accel: 16, turnSpeed: 2.0, radius: 1.4,
        fireCooldownMs: 1400, projectileSpeed: 34, projectileDamage: 10, projectileTtlMs: 3000,
        scale: 1.0, selectable: false,
        ability: { id: "none", name: "—", cooldownMs: Infinity, desc: "" },
    },
    // Coop-only variants (never selectable, never shown in the lobby). Rolled by
    // the room instead of the plain grunt once a wave unlocks them — see
    // COOP.*_UNLOCK_WAVE / *_CHANCE and ArenaRoom.pickBotVariant.
    bot_fast: {
        id: "bot_fast", name: "Bot", role: "Enemy (Fast)",
        maxHp: 45, maxSpeed: 16, accel: 24, turnSpeed: 2.6, radius: 1.2,
        fireCooldownMs: 1100, projectileSpeed: 36, projectileDamage: 9, projectileTtlMs: 2500,
        scale: 0.9, selectable: false,
        ability: { id: "none", name: "—", cooldownMs: Infinity, desc: "" },
    },
    bot_ricochet: {
        id: "bot_ricochet", name: "Bot", role: "Enemy (Ricochet)",
        maxHp: 70, maxSpeed: 9, accel: 14, turnSpeed: 1.8, radius: 1.4,
        fireCooldownMs: 1700, projectileSpeed: 32, projectileDamage: 14, projectileTtlMs: 4000,
        scale: 1.05, selectable: false,
        projectileBounces: 2,
        ability: { id: "none", name: "—", cooldownMs: Infinity, desc: "" },
    },
};
export const DEFAULT_CLASS_ID = "balanced";
/** Classes the lobby lets players pick. */
export const SELECTABLE_CLASSES = Object.values(TANK_CLASSES).filter((c) => c.selectable);
/** Resolve a class id (falls back to balanced). */
export function getClass(id) {
    // Use hasOwnProperty rather than a bare index/truthiness check: plain-object
    // property lookups also resolve inherited keys like "__proto__", "toString"
    // or "constructor" (e.g. TANK_CLASSES["__proto__"] === Object.prototype,
    // which is truthy), so a malicious/unvalidated client-supplied classId could
    // otherwise return a non-TankClass object and NaN-poison the physics step.
    if (id && Object.prototype.hasOwnProperty.call(TANK_CLASSES, id)) {
        return TANK_CLASSES[id];
    }
    return TANK_CLASSES[DEFAULT_CLASS_ID];
}
//# sourceMappingURL=classes.js.map